import { render, staticRenderFns } from "./AssignSavedQuote.vue?vue&type=template&id=3d4fffd1&scoped=true&"
import script from "./AssignSavedQuote.vue?vue&type=script&lang=ts&"
export * from "./AssignSavedQuote.vue?vue&type=script&lang=ts&"
import style0 from "./AssignSavedQuote.vue?vue&type=style&index=0&id=3d4fffd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4fffd1",
  null
  
)

export default component.exports